import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Logo from './Logo';
import Icon from './Icon';
import TopBar from './TopBar';
import { SITE_NAME, SUPPORT_PHONE, SUPPORT_PHONE_TEL } from '../constants/site';

const navLinks = [
  { to: '/', label: 'Home', end: true },
  { to: '/#plans', label: 'Pricing' },
  { to: '/#products', label: 'Products' },
  { to: '/#features', label: 'Features' },
  { to: '/#compare', label: 'Compare' },
  { to: '/#faq', label: 'FAQ' },
  { to: '/contact', label: 'Contact' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const renderLink = (link) => {
    const isHash = link.to.includes('#');

    if (isHash) {
      return (
        <Link key={link.label} to={link.to} className="header__link" onClick={() => setOpen(false)}>
          {link.label}
        </Link>
      );
    }

    return (
      <NavLink
        key={link.label}
        to={link.to}
        end={link.end}
        className={({ isActive }) => `header__link${isActive ? ' is-active' : ''}`}
        onClick={() => setOpen(false)}
      >
        {link.label}
      </NavLink>
    );
  };

  return (
    <>
      <TopBar />
      <header className="header">
        <div className="container">
          <div className="header__bar">
            <Link to="/" aria-label={`${SITE_NAME} home`} onClick={() => setOpen(false)}>
              <Logo />
            </Link>

            <nav className="header__nav" aria-label="Main navigation">
              {navLinks.map(renderLink)}
            </nav>

            <div className="header__actions">
              <a className="header__phone" href={`tel:${SUPPORT_PHONE_TEL}`}>
                <Icon name="phone" size={18} />
                {SUPPORT_PHONE}
              </a>
              <Link to="/#plans" className="btn btn--red">
                Get Protected
              </Link>
            </div>

            <button
              type="button"
              className="header__toggle"
              onClick={() => setOpen((v) => !v)}
              aria-expanded={open}
              aria-controls="mobile-nav"
              aria-label={open ? 'Close menu' : 'Open menu'}
            >
              <Icon name={open ? 'close' : 'menu'} size={22} strokeWidth={2} />
            </button>
          </div>

          {open && (
            <nav id="mobile-nav" className="header__drawer" aria-label="Mobile navigation">
              {navLinks.map(renderLink)}
              <div className="header__drawer-cta">
                <a className="btn btn--outline btn--block" href={`tel:${SUPPORT_PHONE_TEL}`}>
                  <Icon name="phone" size={18} />
                  {SUPPORT_PHONE}
                </a>
                <Link to="/#plans" className="btn btn--red btn--block" onClick={() => setOpen(false)}>
                  Get Protected
                </Link>
              </div>
            </nav>
          )}
        </div>
      </header>
    </>
  );
}
